import { z } from 'zod';

/**
 * NEX-1645 (plan 2026-10-20, Tareas 3.1 and 3.3) — `GET /app/features` (nexvia-api-web
 * `src/modules/app-config/app-config.routes.ts`, next to `version-check`): public, no auth, answers
 * `{ success: true, data: { storage: 'off' | 'registration_only' | 'full' } }` — the storage module's
 * state derived from its two flags (`storageModuleState`, `src/modules/storage/domain/storage-module-state.ts`).
 * Meanings: domain/storage/storage-module.ts.
 *
 * A state this web does not know (one the API adds later) or a missing `storage` reads as `'off'`
 * instead of failing the whole answer: closed is the safe side, the same fallback the query uses while
 * it loads or when the call fails (shared/queries/app-features.ts).
 */
export const AppFeaturesSchema = z.object({
  storage: z.enum(['off', 'registration_only', 'full']).catch('off')
});
